/**
 * @module cercaliagl/InfoMap
 */
/**
 * @typedef {Object} InfoMapOptions
 * @property {string|undefined} title Title
 * @property {string|undefined} content Content
 */
/**
 * @classdesc
 *
 * Class to create an objecto to display using {@link module:cercaliagl/Map~Map#showInfoMap showInfoMap} method.
 * Only `title` and `content` must be provided.
 *
 * @api
 */
var InfoMap = /** @class */ (function () {
    /**
     * @constructor
     * @param {InfoMapOptions} options Options.
     */
    function InfoMap(options) {
        /**
         * @private
         * @type {string}
         */
        this.title_ = options.title;
        /**
         * @private
         * @type {string}
         */
        this.content_ = options.content;
    }
    /**
     * @param {string} title Title.
     * @api
     */
    InfoMap.prototype.setTitle = function (title) {
        this.title_ = title;
    };
    /**
     * @return {string} Get title.
     * @api
     */
    InfoMap.prototype.getTitle = function () {
        return this.title_;
    };
    /**
     * @param {string} content Content.
     * @api
     */
    InfoMap.prototype.setContent = function (content) {
        this.content_ = content;
    };
    /**
     * @return {string} Get content
     * @api
     */
    InfoMap.prototype.getContent = function () {
        return this.content_;
    };
    return InfoMap;
}());
export default InfoMap;
//# sourceMappingURL=InfoMap.js.map